import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import { spaLocation } from "../../lib/href";

type Props = {
  href: string;
  className?: string;
  children: ReactNode;
};

export function AppLink({ href, className, children }: Props) {
  const target = spaLocation(href);
  if ("to" in target) {
    return (
      <Link to={target.to} className={className}>
        {children}
      </Link>
    );
  }
  return (
    <a href={target.href} className={className}>
      {children}
    </a>
  );
}
